import slugify from 'slugify';

const idify = (title) => slugify(title, { lower: true, remove: /[*+~.()'"!:@,]/g });

export default idify;
